/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GlobalOverallResponsesCountQueryVariables = Types.Exact<{
  isUserAllowedToReadComments: Types.Scalars['Boolean'];
  surveyContentType: Types.SurveyContentType;
}>;


export type GlobalOverallResponsesCountQuery = { commentsStatistics: { overallResponsesCount: number } };


export const GlobalOverallResponsesCountDocument = gql`
    query GlobalOverallResponsesCount($isUserAllowedToReadComments: Boolean!, $surveyContentType: SurveyContentType!) {
  commentsStatistics: getStatisticsGlobal(surveyContentType: $surveyContentType) @include(if: $isUserAllowedToReadComments) {
    overallResponsesCount: number_of_treated_recipient_comment
  }
}
    `;

/**
 * __useGlobalOverallResponsesCountQuery__
 *
 * To run a query within a React component, call `useGlobalOverallResponsesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOverallResponsesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOverallResponsesCountQuery({
 *   variables: {
 *      isUserAllowedToReadComments: // value for 'isUserAllowedToReadComments'
 *      surveyContentType: // value for 'surveyContentType'
 *   },
 * });
 */
export function useGlobalOverallResponsesCountQuery(baseOptions: Apollo.QueryHookOptions<GlobalOverallResponsesCountQuery, GlobalOverallResponsesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalOverallResponsesCountQuery, GlobalOverallResponsesCountQueryVariables>(GlobalOverallResponsesCountDocument, options);
      }
export function useGlobalOverallResponsesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalOverallResponsesCountQuery, GlobalOverallResponsesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalOverallResponsesCountQuery, GlobalOverallResponsesCountQueryVariables>(GlobalOverallResponsesCountDocument, options);
        }
export type GlobalOverallResponsesCountQueryHookResult = ReturnType<typeof useGlobalOverallResponsesCountQuery>;
export type GlobalOverallResponsesCountLazyQueryHookResult = ReturnType<typeof useGlobalOverallResponsesCountLazyQuery>;
export type GlobalOverallResponsesCountQueryResult = Apollo.QueryResult<GlobalOverallResponsesCountQuery, GlobalOverallResponsesCountQueryVariables>;